export function initChip(node, userName) {
	setChipColor(node, userName);
	setChipText(node, userName);
}

function setChipColor(n, text) {
	n.style.backgroundColor = generateColor(text);
}

function setChipText(n, text) {
	n.textContent = getChipText(text);
}

export function getChipText(text) {
	const strings = text
		.replaceAll(/[^\p{L} _]/gmu, '')
		.replaceAll('_', ' ')
		.split(' ')
		.filter(s => s.trim() !== '');

	const left  = strings[0] ? getFirstSymbol(strings[0]) : '';
	const right = strings[1] ? getFirstSymbol(strings[1]) : '';

	return (left + right).toUpperCase();
}

function getFirstSymbol(text) {
	return /^[\u{10000}-\u{10FFFF}]/u.test(text)
		? text[0] + text[1]
		: text[0];
}

export function generateColor(str) {
	let hsl = [
		hash(str),
		str.length > 0 ? '100%' : '0%',
		"42%"
	];

	return 'hsl(' + hsl.join() + ')';
}

function hash(str) {
	let hash = 0;

	for (let i = 0; i < str.length; i++) {
		hash = Math.abs(Math.sin(str.charCodeAt(i) + hash) * 360);
	}

	return hash;
}

export function generateHash() {
	let text = '';
	let possible = 'abcdefghijklmnopqrstuvwxyz0123456789-_';

	for (let i = 0; i < 32; i++) {
		text += possible.charAt(Math.floor(Math.random() * possible.length));
	}

	return text;
}

export function diff(a1, a2) {
	const result = [];

	a1.forEach(el => {
		if (a2.indexOf(el) === -1) {
			result.push(el);
		}
	});

	return result;
}
